import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

const DEFAULT_TEXTURE = "https://images.pexels.com/photos/326311/pexels-photo-326311.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1600";

export const CTASection = ({ texture = DEFAULT_TEXTURE }) => {
  const { t } = useLang();
  return (
    <section data-testid="mid-page-cta" className="relative overflow-hidden bg-navy">
      <img src={texture} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-navy/85" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 sm:py-32">
        <Reveal>
          <div className="max-w-3xl">
            <div className="flex items-center gap-4 mb-7">
              <span className="h-px w-10 bg-coral-light" />
              <p className="text-xs uppercase tracking-[0.24em] font-mono text-coral-light">TOKYO · TORONTO</p>
              <span className="h-px w-10 bg-coral-light" />
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-cream-surface">
              {t("common.ctaTitle")}
            </h2>
            <p className="mt-5 text-base leading-relaxed text-[#B7C6E2] max-w-xl">
              Tell us where you are headed — we will tell you honestly what the crossing takes.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/contact"
                data-testid="cta-book-consultation"
                className="group inline-flex items-center gap-2 bg-gold hover:bg-gold-dark text-navy font-semibold px-7 py-3.5 rounded-full transition-colors duration-300"
              >
                {t("common.bookCta")}
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/insights#seminars"
                data-testid="cta-view-seminars"
                className="inline-flex items-center gap-2 border border-cream-surface/40 hover:border-cream-surface text-cream-surface font-medium px-7 py-3.5 rounded-full transition-colors duration-300"
              >
                {t("common.seminarsCta")}
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
